import { useTimeout } from 'react-use';
import { StyledBroadcastLoader } from './styles';

const StaleLoader = () => {
  const [isReady] = useTimeout(2000);
  return isReady() ? <StyledBroadcastLoader loading /> : null;
};

export const CalendarLoader = ({ loading }) =>
  loading ? <StaleLoader /> : null;
